(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tst-calm-hero"] && !Shopify.designMode) return;
  try {
    
  class CalmHeroCarousel {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-calm-hero-track]');
      this.realSlides = Array.from(root.querySelectorAll('[data-calm-hero-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-calm-hero-dot]'));
      this.previousButton = root.querySelector('[data-calm-hero-prev]');
      this.nextButton = root.querySelector('[data-calm-hero-next]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplayEnabled = root.dataset.autoplay === 'true';
      this.delay = Number(root.dataset.delay) || 5000;
      this.realIndex = 0;
      this.trackIndex = 0;
      this.pointerId = null;
      this.startX = 0;
      this.currentX = 0;
      this.startTime = 0;
this.timer = null;
this.dragFrame = null;
this.dragOffset = 0;
      this.isHovered = false;
      this.isFocused = false;
      this.isDesignMode = Boolean(window.Shopify?.designMode);
      this.abortController = new AbortController();
      this.signal = this.abortController.signal;
      root.calmHeroCarousel = this;

      if (!this.track || this.realSlides.length === 0) return;
      this.setupSlides();
      this.bindEvents();
      this.update(false);
      this.scheduleAutoplay();
    }

    setupSlides() {
      if (this.realSlides.length < 2) return;

      const firstClone = this.realSlides[0].cloneNode(true);
      const lastClone = this.realSlides.at(-1).cloneNode(true);

      [firstClone, lastClone].forEach((clone) => {
        clone.removeAttribute('data-calm-hero-slide');
        clone.removeAttribute('data-block-id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      });

      this.track.prepend(lastClone);
      this.track.append(firstClone);
      this.trackIndex = 1;
    }

    bindEvents() {
      const options = { signal: this.signal };

      this.previousButton?.addEventListener('click', () => this.goTo(this.realIndex - 1), options);
      this.nextButton?.addEventListener('click', () => this.goTo(this.realIndex + 1), options);
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)), options);
      });

      this.root.addEventListener('pointerdown', (event) => this.onPointerDown(event), options);
      this.root.addEventListener('pointermove', (event) => this.onPointerMove(event), options);
      this.root.addEventListener('pointerup', (event) => this.onPointerUp(event), options);
      this.root.addEventListener('pointercancel', (event) => this.onPointerUp(event), options);
      this.track.addEventListener('transitionend', () => this.correctLoop(), options);
      this.reducedMotion.addEventListener('change', () => this.onReducedMotionChange(), options);

      this.root.addEventListener('mouseenter', () => {
  this.isHovered = true;
}, options);

this.root.addEventListener('mouseleave', () => {
  this.isHovered = false;
}, options);
      this.root.addEventListener('focusin', () => {
        this.isFocused = true;
        this.clearAutoplay();
      }, options);
      this.root.addEventListener('focusout', (event) => {
        if (!this.root.contains(event.relatedTarget)) {
          this.isFocused = false;
          this.scheduleAutoplay();
        }
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.clearAutoplay();
        else this.scheduleAutoplay();
      }, options);
    }

    onPointerDown(event) {
  if (
    this.realSlides.length < 2 ||
    (event.pointerType === 'mouse' && event.button !== 0) ||
    event.target.closest('button, a')
  ) {
    return;
  }

  this.pointerId = event.pointerId;
  this.startX = event.clientX;
  this.currentX = event.clientX;
  this.dragOffset = 0;
  this.startTime = performance.now();

  this.root.setPointerCapture?.(event.pointerId);
  this.root.classList.add('is-dragging');
  this.clearAutoplay();
}

    onPointerMove(event) {
  if (event.pointerId !== this.pointerId) return;

  this.currentX = event.clientX;
  this.dragOffset = this.currentX - this.startX;

  if (this.dragFrame) return;

  this.dragFrame = requestAnimationFrame(() => {
    const width = this.root.clientWidth || 1;

    let dragPercent = (this.dragOffset / width) * 100;

    dragPercent = Math.max(-100, Math.min(100, dragPercent));

    this.track.style.transform =
      `translate3d(${(-this.trackIndex * 100) + dragPercent}%, 0, 0)`;

    this.dragFrame = null;
  });
}

    onPointerUp(event) {
  if (event.pointerId !== this.pointerId) return;

  this.currentX = event.clientX;

  if (this.dragFrame) {
    cancelAnimationFrame(this.dragFrame);
    this.dragFrame = null;
  }

  const distance = this.currentX - this.startX;
  const elapsed = Math.max(performance.now() - this.startTime, 1);
  const velocity = Math.abs(distance / elapsed);
  const threshold = Math.min(this.root.clientWidth * 0.15, 80);

  if (this.root.hasPointerCapture?.(event.pointerId)) {
    this.root.releasePointerCapture(event.pointerId);
  }

  this.pointerId = null;
  this.dragOffset = 0;
  this.root.classList.remove('is-dragging');

  /*
   * Buộc trình duyệt nhận lại transition trước khi đổi slide.
   * Tránh hiện tượng thả chuột rồi ảnh nhảy ngay lập tức.
   */
  void this.track.offsetWidth;

  if (Math.abs(distance) > threshold || velocity > 0.45) {
    const nextIndex =
      this.realIndex + (distance < 0 ? 1 : -1);

    this.goTo(nextIndex);
  } else {
    this.update(true);
    this.scheduleAutoplay();
  }
}

    goTo(index) {
  if (this.realSlides.length < 2) return;

  this.clearAutoplay();

  this.realIndex =
    (index + this.realSlides.length) % this.realSlides.length;

  if (index < 0) {
    this.trackIndex = 0;
  } else if (index >= this.realSlides.length) {
    this.trackIndex = this.realSlides.length + 1;
  } else {
    this.trackIndex = this.realIndex + 1;
  }

  this.update(true);
  this.scheduleAutoplay();
}

    selectBlock(blockId) {
      const index = this.realSlides.findIndex((slide) => slide.dataset.blockId === blockId);
      if (index < 0) return;

      this.clearAutoplay();
      this.realIndex = index;
      this.trackIndex = this.realSlides.length > 1 ? index + 1 : index;
      this.update(true);
      this.scheduleAutoplay();
    }

    onReducedMotionChange() {
      this.clearAutoplay();
      this.update(false);
      this.scheduleAutoplay();
    }

    normalizeLoopPosition() {
      if (this.realSlides.length < 2) return false;

      if (this.trackIndex === 0) this.trackIndex = this.realSlides.length;
      else if (this.trackIndex === this.realSlides.length + 1) this.trackIndex = 1;
      else return false;

      return true;
    }

    update(animate = true) {
  const shouldAnimate = Boolean(animate);

  if (!shouldAnimate) {
    this.normalizeLoopPosition();
  }

  this.root.classList.toggle('is-jumping', !shouldAnimate);

  this.track.style.transform =
    `translate3d(${-this.trackIndex * 100}%, 0, 0)`;

  this.realSlides.forEach((slide, index) => {
    slide.setAttribute(
      'aria-hidden',
      index === this.realIndex ? 'false' : 'true'
    );
  });

  this.dots.forEach((dot, index) => {
    dot.setAttribute(
      'aria-current',
      index === this.realIndex ? 'true' : 'false'
    );
  });

  if (!shouldAnimate) {
    requestAnimationFrame(() => {
      this.root.classList.remove('is-jumping');
    });
  }
}

    correctLoop() {
      if (!this.normalizeLoopPosition()) return;

      this.update(false);
    }

    scheduleAutoplay() {
  this.clearAutoplay();

  if (
    !this.autoplayEnabled ||
    this.realSlides.length < 2 ||
    document.hidden
  ) {
    return;
  }

  this.timer = window.setTimeout(() => {
    this.goTo(this.realIndex + 1);
  }, Math.max(this.delay, 1000));
}

    clearAutoplay() {
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
    }

    destroy() {
      this.clearAutoplay();
      this.abortController.abort();
      delete this.root.calmHeroCarousel;
    }
  }

  function initializeCalmHeroSection(sectionRoot) {
    sectionRoot.querySelectorAll('[data-calm-hero-carousel]').forEach((root) => {
      if (!root.calmHeroCarousel) new CalmHeroCarousel(root);
    });
  }

  document.querySelectorAll('.tst-calm-hero').forEach(initializeCalmHeroSection);

  document.addEventListener('shopify:section:load', (event) => initializeCalmHeroSection(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-calm-hero-carousel]').forEach((root) => {
      root.calmHeroCarousel?.destroy();
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-calm-hero-carousel]');
    root?.calmHeroCarousel?.selectBlock(event.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const root = event.target.closest('[data-calm-hero-carousel]');
    root?.calmHeroCarousel?.scheduleAutoplay();
  });

  } catch(e) { console.error(e); }
})();
})();
